module.exports = global["Tether"] = require("-!c:\\OpenServer\\domains\\localhost\\prestahero\\1.7\\cosmetics\\themes\\cosmetics\\_dev\\node_modules\\babel-loader\\lib\\index.js??ref--0!.\\tether.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Tether!./~/tether/dist/js/tether.js
// module id = 29
// module chunks = 0